import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { IMicrofrontendManifest, IRegistry } from '@cian/mf-registry/shared';

import {
  fetchGetChatsNotificationsMicrofrontend,
  TGetChatsNotificationsMicrofrontendResponse,
} from '../../repositories/chats-notifications-micro-frontend';

interface IDependencies {
  httpApi: IHttpApi;
  logger: ILogger;
  microfrontendsRegistry: IRegistry;
}

export async function getChatsNotificationsMicrofrontend(
  context: IDependencies,
): Promise<IMicrofrontendManifest | null> {
  const { httpApi, logger, microfrontendsRegistry } = context;

  try {
    const {
      statusCode,
      response: { manifest },
    }: TGetChatsNotificationsMicrofrontendResponse = await fetchGetChatsNotificationsMicrofrontend({
      httpApi,
      parameters: {},
    });

    if (statusCode !== 200) {
      return null;
    }

    microfrontendsRegistry.register(manifest);

    return manifest;
  } catch (ex) {
    logger.error(ex, { domain: 'shared.services.getChatsNotificationsMicrofrontend' });

    return null;
  }
}
